<script setup lang="ts">
import { Modal, Form } from 'ant-design-vue';

import FileAiPromptsTable from '../Table/FileAiPromptsTable.vue';

import InputButton from '@/ui/InputButton.vue';
import type { FileAiPromptFragmentFragment } from '@/graphql/generated/graphql';

export type FileAiPromptValue = FileAiPromptFragmentFragment;

const prompt = defineModel<FileAiPromptValue | undefined>('value');
const visible = defineModel<boolean>('visible');

const formItemContext = Form.useInjectFormItemContext();

const handleRowSelect = (record?: FileAiPromptFragmentFragment) => {
  visible.value = false;
  prompt.value = record;
  formItemContext.onFieldChange();
};

const onRemove = () => {
  prompt.value = undefined;
  formItemContext.onFieldChange();
};
</script>

<template>
  <div>
    <InputButton
      :on-click="() => visible = true"
      :on-remove="onRemove"
      :show-remove="!!prompt"
      data-testid="file-ai-prompt-input-button"
    >
      <template v-if="prompt">
        {{ prompt.type }} - {{ prompt.version }}
      </template>
      <span v-else class="opacity-30">
        Select File AI Prompt
      </span>
    </InputButton>
    <Modal
      :open="visible"
      width="80%"
      title="Select File AI Prompt"
      :footer="false"
      @cancel="() => visible = false"
    >
      <FileAiPromptsTable
        :key="prompt ? `file-ai-prompt-${prompt.id}` : 'no-file-ai-prompt'"
        :set-url="false"
        :on-select="handleRowSelect"
      />
    </Modal>
  </div>
</template>
